
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail/footwear-pos-billing-software",
      function () {
        return require("private-next-pages/retail/footwear-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail/footwear-pos-billing-software"])
      });
    }
  